angular.module('services.newman.TemplatesService', [
  'global'
])

/**
 * The TemplatesService contains utilities for parsing
 * data between templates and models
 *
 * @class TemplatesService
 * @constructor
 * @module services.newman.TemplatesService
 */
.factory('TemplatesService', [
  function () {
    'use strict';

    var service = {
      templates: [],
      models: [],
      setTemplates: function (constants) {
        service.templates = constants.templates;
        service.models = constants.models;
      },
      getTemplate: function (key) {
        return _.cloneDeep(service.templates[key]);
      },
      getModel: function (key) {
        return _.cloneDeep(service.models[key]);
      }
    };

    return service;
  }
]);
